﻿import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import ScrollToTop from './components/ScrollToTop';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import FAQ from './pages/InsuranceFAQ';
import Login from './pages/Login';
import Register from './pages/Register';
import InsuranceLogin from './pages/InsuranceLogin';
import CorporateAccountSetup from './pages/dashboard/CorporateAccountSetup';
import UserManagementDashboard from './pages/dashboard/UserManagementDashboard';
import InsuranceDashboardOverview from './pages/dashboard/InsuranceDashboardOverview';
import FraudDetectionDashboard from './pages/dashboard/FraudDetectionDashboard';
import AlertDecisionDashboard from './pages/dashboard/AlertDecisionDashboard';
import ProactiveRiskAnalytics from './pages/dashboard/ProactiveRiskAnalytics';
import ClaimsManagement from './pages/dashboard/ClaimsManagement';

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/insurance-login" element={<InsuranceLogin />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<ProtectedRoute><InsuranceDashboardOverview /></ProtectedRoute>} />
          <Route path="/dashboard/setup" element={<ProtectedRoute requiredPermission="all"><CorporateAccountSetup /></ProtectedRoute>} />
          <Route path="/dashboard/user-management" element={<ProtectedRoute requiredPermission="all"><UserManagementDashboard /></ProtectedRoute>} />
          <Route path="/dashboard/fraud-detection" element={<ProtectedRoute requiredPermissions={['all', 'view_fraud_detection']}><FraudDetectionDashboard /></ProtectedRoute>} />
          <Route path="/dashboard/alerts" element={<ProtectedRoute requiredPermissions={['all', 'view_fraud_detection']}><AlertDecisionDashboard /></ProtectedRoute>} />
          <Route path="/dashboard/risk-analytics" element={<ProtectedRoute requiredPermissions={['all', 'view_proactive_risk']}><ProactiveRiskAnalytics /></ProtectedRoute>} />
          <Route path="/dashboard/claims" element={<ProtectedRoute requiredPermissions={['all', 'view_operational_efficiency', 'process_claims']}><ClaimsManagement /></ProtectedRoute>} />
        </Routes>
        <Toaster position="top-right" />
      </Router>
    </AuthProvider>
  );
}

export default App;
